import React from "react";
import { Link } from "react-router-dom";
import { FaArrowRightLong } from "react-icons/fa6";
import userImage from "../../../../Images/login1.png";
import courseImage from "../../../../Images/course.png"
import Wallet3 from "../../../../Images/LE_coin.png";
import CourseProgressCard from "./CourseProgressCard";

const WelcomeCard = ({ hasPurchased }) => {
  return (
    <div className="h-40 sm:h-44 rounded-2xl shadow-xl bg-gradient-to-r from-[#F6F0FA] to-[#FFF] flex">
      

      <div className="mt-4 ml-2">
        <img src={userImage} className="w-64 " />
      </div>
      <div className="sm:flex">
        <div className="flex  flex-col justify-center item-center ">
            <h2 className="text-2xl font-bold text-bgBlue">
            Welcome, Komal
            </h2>

            {!hasPurchased && (
            <p className="text-sm text-black">
            Join millions of people from around the world learning together,
            Online learning.
            </p>
            )}
            {hasPurchased && (
            <p className="hidden sm:block text-sm text-black">
            Join millions of people from around the world learning together,
            Online learning.
            </p>
            )}

            {!hasPurchased && (
                <div className="flex justify-center mt-4 ">
                    
                    <Link to="/dash/quize">
                        <div className="w-60 flex py-2 justify-center gap-4 rounded-full bg-bgBlue text-white shadow-[4px_6px_#A695AE]">
                        <button className="font-bold">Demo Start Quiz</button>
                        <FaArrowRightLong />
                        </div>
                    </Link>
                </div>
            )}
            
        </div>

        {/* Content */}
        {hasPurchased && (

        <div className="sm:w-2/4 flex flex-col justify-center item-center ml-4 mr-2">
            <div className="flex justify-center mb-2">
                <img src={courseImage} className="w-6 sm:w-8" />
                <h3 className="sm:text-lg font-semibold text-[#4B2D83] mb-2 mt-2">
                GK Master Knowledge
                </h3>
            </div>

            {/* Progress Bar */}
            <div className="mx-8 mt-2 bg-gray-200 rounded-full h-2 ">
            <div
                className="bg-gradient-to-r from-[#FFB27A] to-[#FF782D] h-2 rounded-full transition-all"
                style={{ width: `${35}%` }}
            />
            </div>

            <div className="flex items-center justify-end">
            

            <span className="text-sm font-semibold text-green-600">
                {35}%
            </span>
            </div>
            <div className="flex justify-center ">
            <Link to="/dash/quize">
                <div className="w-60 flex py-2 justify-center gap-4 rounded-full bg-bgBlue text-white shadow-[4px_6px_#A695AE]">
                <button className="font-bold">Start Quiz</button>
                <FaArrowRightLong />
                </div>
            </Link>
            </div>
        </div>
        )}
        
        </div>
      
      <img src={Wallet3} className="ml-10 hidden md:block" />

       
    </div>
  );
}

export default WelcomeCard;
